import { FormConfig } from 'stories/forms/FormBuilder/FormBuilder.types';
import {
  CreateClientRequest,
  UpdateClientRequest,
  FilterOptionDto,
} from '@act/shared/data-transfer-objects';

export interface CustomerFormConfigProps {
  createMode: boolean;
  isRecordEditable: boolean;
  isConfigEditable: boolean;
  medCenterOptions: Array<{ key: string; label: string; value: string }>;
  defaultphoneOptions: Array<{ key: string; label: string; value: string }>;
  feedbackPhoneOptions: Array<{ key: string; label: string; value: string }>;
  allTerms: Array<{ id: number; name: string }>;
  teamOptions: Array<{ label: string; value: number }>;
}

export const createCustomerFormConfig = ({
  createMode,
  isRecordEditable,
  isConfigEditable,
  medCenterOptions,
  defaultphoneOptions,
  feedbackPhoneOptions,
  allTerms,
  teamOptions,
}: CustomerFormConfigProps) => {
  const customerRecordFormConfig: FormConfig<
    CreateClientRequest | UpdateClientRequest
  > = [
    {
      type: 'input',
      name: 'name',
      label: 'Customer Name',
      input: 'text',
      disabled: isRecordEditable,
      props: {
        required: createMode,
      },
    },
    {
      type: 'input',
      name: 'displayName',
      label: 'Display Name',
      input: 'text',
      disabled: isRecordEditable,
      props: {
        required: createMode,
      },
    },
    {
      type: 'input',
      name: 'reemaWebsite',
      label: 'Website',
      input: 'text',
      disabled: isRecordEditable,
      props: {
        required: createMode,
      },
    },
    {
      type: 'input',
      name: 'avonMedicalCenterId',
      label: 'Avon Medical Center',
      input: 'select',
      disabled: isRecordEditable,
      props: {
        options: medCenterOptions || [],
        fullWidth: true,
      },
    },
    {
      type: 'input',
      name: 'internalPhoneNumberId',
      label: 'Market Number',
      input: 'select',
      disabled: isRecordEditable,
      props: {
        options: defaultphoneOptions ?? [],
        fullWidth: true,
      },
    },
    {
      type: 'input',
      name: 'feedbackNumberId',
      label: 'Feedback Number',
      input: 'select',
      disabled: isConfigEditable,
      props: {
        options: feedbackPhoneOptions ?? [],
        fullWidth: true,
      },
    },
    {
      type: 'input',
      name: 'hasADTFeed',
      label: 'Has ADT Feed',
      input: 'checkbox',
      disabled: isRecordEditable,
    },
  ];

  const customerConfigFormConfig: FormConfig<
    CreateClientRequest | UpdateClientRequest
  > = [
    {
      type: 'input',
      name: 'smsReEngagementThreshold',
      label: 'SMS Threshold',
      input: 'number',
      disabled: isConfigEditable,
      props: {
        required: createMode,
      },
    },
    {
      type: 'input',
      name: 'callEngagementLengthRequirementInMinutes',
      label: 'Call Engagement Length',
      input: 'number',
      disabled: isConfigEditable,
      props: {
        required: createMode,
      },
    },
    {
      type: 'input',
      name: 'terms',
      label: 'Consents',
      input: 'checkboxGroup',
      disabled: isConfigEditable,
      props: {
        required: createMode,
        options: allTerms.map(term => ({
          label: term.name,
          value: term.id,
        })),
      },
    },
    {
      type: 'input',
      name: 'teamIds',
      label: 'Teams',
      input: 'autocomplete',
      disabled: isConfigEditable,
      props: {
        options: teamOptions,
        multiple: true,
        limitTags: 2,
        getOptionLabel: (option: FilterOptionDto) => option.label,
      },
    },
  ];

  return {
    customerRecordFormConfig,
    customerConfigFormConfig,
  };
};
